export const SCAN_LIST_REQUEST = 'SCAN_LIST_REQUEST';
export const SCAN_LIST_SUCCESS = 'SCAN_LIST_SUCCESS';
export const SCAN_LIST_FAILURE = 'SCAN_LIST_FAILURE';